
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";

import MenuIcon from "@/components/icons/MenuIcon.vue";

export default defineComponent({
  components: {
    MenuIcon
  },
  setup() {
    const route = useRoute();
    const isHome = computed(() => route.name === "Home");

    return {
      isHome
    };
  }
});
